import {
  profit_breakdown_area,
  profit_breakdown_cluster,
  profit_breakdown_overall,
  profit_breakdown_branch,
  profit_breakdown_branch_concurrent_request,
} from "../../services/reports/profit_breakdown_service";
import { actionTypes } from "../action_types";

const defaultData = {};

const createProfitBreakdownAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data !== null ? resp.data : defaultData,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetProfitBreakdownOverall = createProfitBreakdownAction(
  profit_breakdown_overall,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_GET_OVERALL
);

export const GetProfitBreakdownCluster = createProfitBreakdownAction(
  profit_breakdown_cluster,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_GET_CLUSTER
);

export const GetProfitBreakdownArea = createProfitBreakdownAction(
  profit_breakdown_area,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_TARGET_GET_AREA
);

export const GetProfitBreakdownBranch = createProfitBreakdownAction(
  profit_breakdown_branch,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_TARGET_GET_BRANCH
);

export const GetProfitBreakdownBranchConcurrentRequest =
  createProfitBreakdownAction(
    profit_breakdown_branch_concurrent_request,
    actionTypes.REPORTS_PROFIT_BREAKDOWN_TARGET_GET_BRANCH
  );
